<template>
    <ProgramacionesSecuenciales :grupos="grupos" @reset-groups="resetGroups" @reset-sensores="resetSensors" :variadores="variadores" :electrovalvulas="electrovalvulas" :sensores="sensores"/>
</template>

<script>
// import ProgramacionesComponent from "@/components/ProgramacionesComponent.vue";
import { getGrupos } from "@/data/gruposData";
import { getProgramaciones } from "@/data/programacionesData";
import { getVariadores } from "@/data/variadoresData";
import { getValvulas } from "@/data/valvulasData";
import { getSensores } from "@/data/sensoresData";
import ProgramacionesSecuenciales from '@/components/ProgramacionesSecuenciales.vue';
// import ProgramacionParametrica from '@/components/ProgramacionParametrica.vue';
export default {
  components: { ProgramacionesSecuenciales },
  data() {
    return {
      variadores: getVariadores(),
      programaciones: getProgramaciones(),
      grupos: getGrupos(),
      sensores: getSensores(),
      electrovalvulas: getValvulas(),
      loader: false,
    };
  },

  methods: {
    resetGroups() {
      this.grupos = this.grupos.map(group => ({
        ...group,
        disabled: false
      }));
    },
    resetSensors() {
      this.sensores = this.sensores.map(sensor => ({
        ...sensor,
        disabled: false
      }));
    },
  },
};
</script>

<style>
</style>